import { Extension } from "@tiptap/core";

declare module "@tiptap/core" {
  interface Commands<ReturnType> {
    resetContent: {
      resetContent: () => ReturnType;
    };
  }
}

export const ResetContent = Extension.create({
  name: "ResetContent",
  //@ts-ignore
  addCommands() {
    return {
      resetContent:
        () =>
        ({ commands, editor }) => {
          const result = commands.clearContent(true);
          // Reset custom state
          editor.storage.customState = {} as any;

          return result;
        },
    };
  },
});
